import PropTypes from "prop-types";

export const SubTicketPropsInterface = PropTypes.shape({
  id: PropTypes.number,
  created_at: PropTypes.string,
  created_by: PropTypes.number,
  updated_at: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  updated_by: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  deleted_at: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  deleted_by: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  ticket_id: PropTypes.number,
  name: PropTypes.string,
  code: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.string,
  proposal_amount: PropTypes.number,
  claim_amount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  budget_name: PropTypes.string,
  proposal_file_urls: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.oneOf([null]),
  ]),
  claim_file_urls: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.oneOf([null]),
  ]),
  management_file_urls: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.oneOf([null]),
  ]),
  payment_file_urls: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.oneOf([null]),
  ]),
});
